<template>
  <div class="m-0 h-screen-fixed fixed pin pbc-modal-background flex justify-center left-0 top-0 right-0 bottom-0 inset-y-auto pbc-z-level-2" @click.self='$emit("close")'>
    <div class="animated fadeInUp fixed shadow-inner max-w-md md:max-w-3xl pin-b pin-x align-top m-auto justify-center w-full shadow flex flex-col mb-4 flex h-full">
        <div :style='backgroundStyle' class="m-2 rounded flex flex-col overflow-auto" style='box-sizing: border-box' :class="fullHeight? 'grow':''">
          <div v-if='!disableTitle' class="border-b border-solid border-grey-500">
            <h2 class="text-2xl text-center font-hairline md:leading-loose text-grey">{{title}}</h2>
          </div>
          <div class="m-2 flex-1 overflow-auto leading-normal text-center" :class='slotClass'>
            <slot name='default' :close='close' :done='done' />
          </div>
          <slot name='controls' :close='close' :done='done'>
            <div class="py-3 w-full flex justiy-center inline-flex justify-center border-t border-solid border-grey-500 shadow-inner">
              <pbc-button v-if='showCancel' @click="close">
                <close class="mx-2"/>
                <span class="mr-2">Cancel</span>
              </pbc-button>
              <pbc-button v-if='showDone' @click="$emit('done')" >
                <check class="mx-2" />
                <span class="mr-2">Done</span>
              </pbc-button>
            </div>
          </slot>
        </div>
	</div>
</div>
</template>
<script>
import Check from '@icons/Check.vue';
import Close from '@icons/Close.vue';
export default {
  props:{
    title:{
      type:String,
      default:'Title'
    },
    disableTitle:{
      type:Boolean,
      default:false
    },
    showCancel:{
      type:Boolean,
      default:true
    },
    showDone:{
      type:Boolean,
      default:true
    },
    backgroundColor:{
      type:String,
      default:'#ffffff'
    },
    fullHeight: {
      type: Boolean,
      default: true
    },
    enableBackground: {
      type: Boolean,
      default: true
    }
  },
  components:{
    Check,
    Close
  },
  methods:{
    close(dontEmit) {
      if (!dontEmit) {
        this.$emit('close');
      }
    },
    done() {
      this.$emit('done');
    }
  },
  computed: {
    backgroundStyle() {
      if (this.enableBackground) {
        return {
          'background-color':'#ffffff'
        }
      }
      return {
      }
    },
    slotClass() {
      if (this.enableBackground) {
        return 'bg-gray-400';
      }
      return '';
    }
  }
}
</script>
